import { Validator } from '@/entities/validation';
import { Schedule } from './model';

export const validate: Validator<Schedule> = record => [];
